import { fmtMoney, fmtDateTime, imgSrc } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { StatusBadge } from "@/components/StatusBadge";

export const ThreadEntry = ({ entry }) => {
  const isOffer = entry.action === "offer" || entry.action === "counter";
  const label = { offer: "Initial offer", counter: "Counter offer", accept: "Accepted", decline: "Declined" }[entry.action] || entry.action;
  return (
    <div className="rounded-xl border bg-card p-3">
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-semibold capitalize">
          {entry.by_role === "client" ? "Client" : "Model side"} · {label}
        </span>
        <span className="font-mono-plex text-[10px] text-muted-foreground">{fmtDateTime(entry.created_at)}</span>
      </div>
      {isOffer && entry.amount != null && <p className="mt-1 font-display text-xl">{fmtMoney(entry.amount)}</p>}
      {entry.action === "accept" && entry.amount != null && (
        <p className="mt-1 text-sm">Agreed at <span className="font-semibold">{fmtMoney(entry.amount)}</span></p>
      )}
      {entry.note && <p className="mt-1 text-sm text-muted-foreground">“{entry.note}”</p>}
    </div>
  );
};

export const NegotiationThread = ({ thread }) => (
  <div className="space-y-2">
    <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Negotiation</p>
    <div data-testid="booking-negotiation-thread" className="space-y-2">
      {(thread || []).map((t) => (
        <ThreadEntry key={t.id} entry={t} />
      ))}
    </div>
  </div>
);

export const BookingThreadList = ({ bookings, selectedId, onSelect }) => (
  <div data-testid="inbox-thread-list" className="space-y-2 lg:col-span-4">
    {bookings.map((b) => (
      <button
        key={b.id}
        data-testid="inbox-thread-item"
        onClick={() => onSelect(b)}
        className={`flex w-full items-center gap-3 rounded-xl border p-3 text-left transition-[background-color,border-color] hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
          selectedId === b.id ? "border-[hsl(174,38%,34%)] bg-muted" : "bg-card"
        }`}
      >
        <div className="h-14 w-11 shrink-0 overflow-hidden rounded-lg bg-muted">
          {imgSrc(b.model_image) && <img src={imgSrc(b.model_image)} alt="" className="h-full w-full object-cover" />}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <p className="truncate text-sm font-semibold">{b.model_name}</p>
            <StatusBadge status={b.status} />
          </div>
          <p className="truncate text-xs text-muted-foreground">{b.job?.title}</p>
          <div className="mt-0.5 flex items-center justify-between">
            <p className="truncate text-[11px] text-muted-foreground">{b.client_company_name}</p>
            {b.awaiting === b.my_side && ["pending", "countered"].includes(b.status) && (
              <Badge className="rounded-full bg-[hsl(174,38%,34%)] text-[10px] text-white">Your turn</Badge>
            )}
          </div>
        </div>
      </button>
    ))}
  </div>
);
